import { DonDto, IncidentDto, VisiteDto } from "src/api/models";

export namespace Visites {

  export class GetDetail {
    static readonly type = '[Visites] Get visite detail';
    constructor(public visiteId: number) {}
  }

  export class UpdateVisite {
    static readonly type = '[Visites] update visite';
    constructor(public visite: VisiteDto) {}
  }

  export class UpdateDon {
    static readonly type = '[Visites] update don';
    constructor(public don: DonDto) {}
  }

  export class GetIncidentPhotos {
    static readonly type = '[Visites] Get photos incident';
    constructor(public incidentId: number) {}
  }

  export class GetTypesIncidents {
    static readonly type = '[Visites] Get types incidents';
  }

  export class PrepareIncident {
    static readonly type = '[Visites] Prepare new incident';
    constructor(public incident: IncidentDto) {}
  }

  export class CreateIncident {
    static readonly type = '[Visites] Create incident';
    constructor(public incident: IncidentDto) {}
  }

  export class UpdateIncident {
    static readonly type = '[Visites] Update incident';
    constructor(public incidentId: number, public incident: IncidentDto) {}
  }

  export class AddIncidentPhotoPDA {
    static readonly type = '[Visites] Add incidentPhoto as PhotoPDA';
    constructor(public incidentId: number, public photoPDAIds: number[]){}
  }
}
